export default __webpack_public_path__ + "static/media/imageupload.76d6ea39.svg";